let session = new Date();
session.setSeconds(session.getSeconds() + 1);

let month = new Date();
month.setMonth(month.getMonth() + 1);


function showBanner(currentBanner){
	if(currentBanner === 'green'){
		$('.section-header__banner .banner.black').removeClass('active')
		$('.section-header__banner .banner.green').addClass('active')
	} else if(currentBanner === 'black'){
		$('.section-header__banner .banner.black').addClass('active')
		$('.section-header__banner .banner.green').removeClass('active')
	}
}

if(getCookie('activeBanner')){
	let currBanner = getCookie('currentBanner');
	showBanner(currBanner)
} else {
	setCookie('activeBanner', true, options = {expires: session} )
	if(getCookie('currentBanner')){
		let currentBanner = getCookie('currentBanner');
		if (currentBanner === 'black'){
			currentBanner = 'green';
		} else if (currentBanner === 'green'){
			currentBanner = 'black';
		}
		setCookie('currentBanner',currentBanner)
		showBanner(currentBanner);
	} else {
		setCookie('currentBanner', 'green', options = {expires: month} )
		let curB = getCookie('currentBanner')
		showBanner(curB);
	}
}

function setCookie(name, value, options = {}) {
	
	options = {
		
		path: '/',
		...options
	};
	
	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}
	
	let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
	
	for (let optionKey in options) {
		updatedCookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			updatedCookie += "=" + optionValue;
		}
	}
	
	document.cookie = updatedCookie;
}

function getCookie(name) {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}
